module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/bass-v2-2b37c33319f2666ade43563734d39d87.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/bass-v2.svg
// module id = ljUY
// module chunks = 1 3 10 12 18